import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { AuthService } from '@core/auth/auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.sessionChecked$.pipe(
    filter((checked) => checked),
    take(1),
    map(() => {
      if (auth.isAdmin) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
